module.exports = {"530125001":"匡远街道","530125002":"汤池街道","530125003":"南羊街道","530125102":"北古城镇","530125103":"狗街镇","530125105":"竹山镇","530125106":"马街镇","530125201":"耿家营彝族苗族乡","530125202":"九乡彝族回族乡","530125404":"昆明阳宗海风景名胜区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530125.json
// module id = 2547
// module chunks = 0